import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
  ViewChild,
  Renderer2,
} from '@angular/core';

import { EngagementService } from '../../engagement/engagement.service';
import { Subscription, Observable } from 'rxjs';
import { EngagementBookingVM } from '../../../Models/EngagementBookingVM';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
  FormBuilder,
  FormArray,
} from '@angular/forms';
import { BookingGridActionService } from '../../../Models/BookingGridActionService';
import { Response } from '../../../Models/Response';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ResourceDto } from '../../../Models/ResourceDto';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrderPipe } from 'ngx-order-pipe';
import { SwapResourceVM } from '../../../Models/SwapResourceVM';
import * as moment from 'moment';
import {
  ActionDescription,
  MeraActionDescription,
  UiViewSourceEnum,
} from 'app/shared/enum';
import { IndividualService } from '../../individual/individual.service';
import { CurrentWeekActionDTO } from '../../../Models/CurrentWeekActionDTO';
import { FilteredData } from 'app/Models/FilteredData';
import { SharedServicesService } from 'app/shared/sharedservices/shared-services.service';
import { BeyondDateFilterBookingActionsDto } from 'app/Models/BeyondDateFilterBookingActionsDto';
import { EngagementActivityVm } from 'app/Models/EngagementActivity';
import { BookingComponentVm } from 'app/Models/BookingComponent';
import { UserVM } from 'app/Models/UserVM';

@Component({
  selector: 'app-swap-engagement',
  templateUrl: './swap-engagement.component.html',
  styleUrls: ['./swap-engagement.component.css'],
})
export class SwapEngagementComponent implements OnInit {
  @Input() currentWeekActionDTO: CurrentWeekActionDTO;
  @Input() public bookingData: EngagementBookingVM;
  @Input() IsReplaceBeyondDatefilter: boolean;
  @Input() selectedInstanceId: number;
  @Input() selectedEngagement: number;
  public childRows: EngagementBookingVM;

  colorTheme = 'theme-dark-blue';
  bsConfig: Partial<BsDatepickerConfig>;
  //@Input()
  public calledFromChild: boolean;
  bookingType = '';
  engagementCode = '';
  Engagement = '';
  engagementAllocationText = '';
  engagementAllocationTypeValue: any;
  description = '';
  loading = '';
  startDate: Date = null;
  endDate: Date = null;
  bsRangeValue: Date[];
  hours: number;
  bookingId: number;
  resourceId: number;
  OldresourceId: number;
  selectedJobAssignment = ['', '', '', '', ''];
  jobId: number;
  unconfirmed: boolean;
  ghost: boolean;
  engagementAllocationPercentSelected = false;
  closeModalWindow = false;
  formGroup: FormGroup;
  booking: EngagementBookingVM;
  response: Response;
  eventData: BookingGridActionService;
  editBookingSubscription: Subscription;
  engagementStatus = '';
  engagementServiceLine = '';
  ResourceName: string;
  ReplaceResourceName: string;
  LocationDescription: string;
  //RankDescription: string;
  ActivityTypeDescription: string;
  resourceNameZZ: boolean;
  searchBookingSubscription: Subscription;
  isAllChecked: boolean = true;
  sortedEngagementList: any[];
  resourceList: ResourceDto[];
  sortedResourceList: any[];
  resourceListoptions: any[];
  results: any[];
  selectedResourceItem: any = '';
  //resourceRank: string;
  resourceLocation: string;
  validResource = true;
  public view: Observable<any>;
  //Rank: string;
  Location: string;
  autocompleteResetvalue = '';
  SLDescription: string;
  departmentDescription: string;
  competencyDescription: string;
  currentUserName: any;
  currentUserId: any;
  currentUserEmail: any;
  resource: ResourceDto;

  bookingList: EngagementBookingVM[];
  showSearchListBookingComponent: boolean = false;
  showSearchBCList: any = [false, false, false, false, false];
  selectedEngagementBooking: any = [];
  showSearchBCLoader: any = [false, false, false, false, false];
  bookingList1: EngagementBookingVM[];
  bookingListSubscription: Subscription;
  mySelection: any[] = [];
  selectedCallback = (args) => args.dataItem;
  // selectableSettings: SelectableSettings;
  public gridData: any[];
  private editedRowIndex: number;

  public rowsSelected: number[] = [];
  public hiddenColumns: string[] = [];
  // public groups: GroupDescriptor[] = [];
  format = '#.# \\%';
  public ChildRowDiv = true;
  public checkboxStatus = false;
  public allRowsSelected: Boolean;
  selectionToggleCallback: any;
  // public selectAllState: SelectAllCheckboxState = 'unchecked';

  public selectAll: boolean = false;
  selectedItemIDs: any[] = [];
  selectedItems: any[] = [];
  public test: boolean;
  ChildRowsExist: any;

  checkboxOnly: boolean;
  disabledchildgrid = true;
  showSearchList: boolean = false;
  showSearchLoader: boolean = false;
  myFormGroup: FormGroup;
  isValidationRequired: boolean = false;
  public checkindex: number;
  public checkstatus: boolean;
  swapResource: SwapResourceVM[];
  swapBooking: EngagementBookingVM[];
  swapResourceSubscription: Subscription;
  hoursValidationResultList: boolean[];
  swapResourceList: any[] = [];
  bsRangeDate: Date[];
  confirmHours: boolean = false;
  hoursValid: boolean = true;
  isPercentageSelected: boolean = false;
  public onlyParent: boolean = false;
  public onlyParentDirtyFlag: boolean;
  engagementComponentList: any = [];
  buttonText = 'Submit';
  user: UserVM;
  overallocationerror: boolean = true;
  // startOfWeek = new Date();
  checkBoxDisbFlg = true;
  noresourcFoundFlg = false;
  thisDay = new Date();
  //todaysDate = new Date(this.thisDay.getFullYear(), this.thisDay.getMonth(), this.thisDay.getDate(), 0, 0, 0);
  todaysDate =
    this.thisDay.getFullYear() +
    '-' +
    ('0' + (this.thisDay.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + this.thisDay.getDate()).slice(-2) +
    'T00:00:00.000Z';
  startOfWeek = this.getFirstDateOfWeek(this.todaysDate);
  objFilteredData: FilteredData;
  jobAssignmentList;

  constructor(
    private engagementServices: EngagementService,
    public restService: EngagementService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    private orderPipe: OrderPipe,
    private fb: FormBuilder,
    private individualServices: IndividualService,
    public sharedService: SharedServicesService
  ) {
    this.view = this.restService;
    this.bookingList = [];
    // this.bookingList1 = [];
    this.swapResource = [];
    this.swapBooking = [];

    this.formGroup = new FormGroup({
      editPeriod: new FormControl('', [Validators.required]),
      EngagementComponent: new FormControl('', [Validators.required]),
      editLoading: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(?!0*\.?0+$)\d*\.?\d{1,2}$/),
        Validators.max(2147483647),
      ]),
      EngagementResourceName: new FormControl('', []),
      editSave: new FormControl({ disabled: true }),

      editUnconfirmed: new FormControl('', []),
      editGhost: new FormControl('', []),
      selectAll_chk: new FormControl('', []),

      Notes: new FormControl('', []),
    });
  }

  userprofileform = this.fb.group({
    fbhours: this.fb.array([this.fb.control('')]),
  });

  ngOnInit() {
    // this.getCurrentWeek();
    this.sharedService.selectedFilterData.subscribe((value: FilteredData) => {
      this.objFilteredData = value; //v1
      console.log(this.objFilteredData);
    });
    this.getEngagementActivityData();
    this.enabledWeek(
      !this.currentWeekActionDTO.IsDisabledReplaceBookingCurrWeek
    );
    this.user = JSON.parse(sessionStorage.getItem('resource'));
    this.resource = new ResourceDto();
    this.currentUserName = this.user.ResourceName;
    this.currentUserEmail = this.user.Email;
    this.currentUserId = sessionStorage.getItem('resourceId');
    const currentDate = new Date();
    this.bsConfig = Object.assign(
      {},
      {
        containerClass: this.colorTheme,
        showWeekNumbers: false,
        minDate: currentDate,
        rangeInputFormat: 'DD-MM-YYYY',
      }
    );
    this.resourceNameZZ = true;
    this.booking = new EngagementBookingVM();
    this.response = new Response();

    this.engagementServices.swapEvent.subscribe((data) => {
      this.eventData = data;
      this.SetData(this.eventData);
      this.childRows = data.dataItem;
    });

    this.engagementServices.currentMessageEngagementAllocation.subscribe(
      (isPercentageSelected) => {
        this.setEngagementAllocation(isPercentageSelected);
      }
    );

    this.sortedEngagementList = [];
    this.results = [];

    this.getBookingList();

    let group = {};
    group['number_of_resource'] = new FormControl('');
    this.myFormGroup = new FormGroup(group);
  }

  getEngagementActivityData() {
    const param = new EngagementActivityVm();
    param.EngagementID = this.selectedEngagement;
    param.InstanceId = this.selectedInstanceId;
    this.restService.getEngagementActivity(param).subscribe((data) => {
      this.jobAssignmentList = data;
    });
  }

  onJobAssignmentChange(event, i) {
    this.selectedJobAssignment[i] = event.value;
  }

  isValidInput(fieldName): boolean {
    return (
      this.formGroup.controls[fieldName].invalid &&
      (this.formGroup.controls[fieldName].dirty ||
        this.formGroup.controls[fieldName].touched)
    );
  }
  SetData(rowdata: BookingGridActionService) {
    this.formGroup.reset();
    this.ResourceName = rowdata.dataItem.ResourceName;
    this.ReplaceResourceName = rowdata.dataItem.ResourceName;
    if (/^ZZ/.test(this.ResourceName)) {
      this.resourceNameZZ = false;
    }
    //this.RankDescription = rowdata.dataItem.RankDescription;
    this.ActivityTypeDescription = rowdata.dataItem.ActivityTypeDescription;
    this.LocationDescription = rowdata.dataItem.LocationDescription;
    this.SLDescription = rowdata.dataItem.ServiceLineDescription;
    this.departmentDescription = rowdata.dataItem.DepartmentDescription;
    this.competencyDescription = rowdata.dataItem.CompetencyDescription;
    this.bookingId = rowdata.dataItem.BookingId;
    this.resourceId = rowdata.dataItem.ResourceId;
    this.OldresourceId = rowdata.dataItem.ResourceId;
    this.jobId = rowdata.dataItem.JobId;
    this.startDate = rowdata.dataItem.StartDate;
    this.endDate = rowdata.dataItem.EndDate;
    this.Engagement = rowdata.dataItem.Engagement;
    this.engagementCode = rowdata.dataItem.EngagementCode;
    this.loading = rowdata.dataItem.Loading;
    this.hours = rowdata.dataItem.Hours;
    this.bsRangeValue = [
      new Date(rowdata.dataItem.StartDate),
      new Date(rowdata.dataItem.EndDate),
    ];
    this.description = ''; //rowdata.dataItem.Description;
    this.bookingType = rowdata.dataItem.BookingType;
    if (this.bookingType.includes('Unconfirmed')) {
      this.unconfirmed = true;
    } else {
      this.unconfirmed = false;
    }
    this.ghost = rowdata.dataItem.Ghost;
    this.engagementStatus = rowdata.dataItem.JobStatus;
    this.engagementServiceLine = rowdata.dataItem.ServiceLineDescription;
    this.setEngagementAllocation(this.engagementAllocationPercentSelected);
    //this.setUnconfirmed();
    this.formGroup.controls['editSave'].disable();

    // this.index = 0;
    for (let item of this.bookingList) {
      this.bsRangeValue = [new Date(item.StartDate), new Date(item.EndDate)];
    }
  }

  public index: number;
  setDate() {
    this.index = 0;
  }

  mouseEnter() {
    if (this.engagementAllocationPercentSelected) {
      //this.engagementAllocationTypeValue = this.engagementAllocationTypeValue.replace('% ', '');
    }
  }

  mouseLeave() {
    if (this.engagementAllocationPercentSelected) {
      this.engagementAllocationTypeValue = this.engagementAllocationTypeValue;
    }
  }

  setEngagementAllocation(isPercentageSelected) {
    if (!isPercentageSelected) {
      this.engagementAllocationText = 'Hours';
      this.engagementAllocationTypeValue = this.hours;
      this.isPercentageSelected = false;
    } else {
      this.engagementAllocationText = 'Loading %';
      this.isPercentageSelected = true;
      if (this.loading !== '' && this.loading != null) {
        this.engagementAllocationTypeValue = this.loading;
      }
    }
    this.engagementAllocationPercentSelected = isPercentageSelected;
  }

  onEditSubmit() {
    //if (!this.myFormGroup.invalid && this.ChildRecordsDisable == false) {
    if (!this.myFormGroup.invalid && this.ChildRecordsDisable == false) {
      if (this.ReplaceResourceName != this.ResourceName) {
        this.bookingList.forEach((num, i) => {
          if (this.myFormGroup.get('chk_' + i).value == true) {
            const selectedRow = new SwapResourceVM();
            if (!this.isPercentageSelected) {
              selectedRow.Hours = this.myFormGroup.get('Hours_' + i).value;
              selectedRow.IsPercentSelected = false;
            } else {
              selectedRow.Loading = this.myFormGroup.get('Hours_' + i).value;
              selectedRow.IsPercentSelected = true;
            }
            selectedRow.StartDate = this.myFormGroup
              .get('Periods_' + i)
              .get('dtStart').value;
            selectedRow.EndDate = this.myFormGroup
              .get('Periods_' + i)
              .get('dtEnd').value;
            selectedRow.BookingId = this.bookingId;
            selectedRow.ResourceId = this.resourceId;
            selectedRow.Unconfirmed = this.myFormGroup.get(
              'Unconfirmed_' + i
            ).value;
            selectedRow.Ghost = this.myFormGroup.get('Ghost_' + i).value;
            this.swapResource.push(selectedRow);
          }
        });

        //alert(JSON.stringify(this.swapResource));

        this.swapResourceSubscription = this.engagementServices
          .validateReplaceHours(this.swapResource)
          .subscribe((data: any) => {
            this.hoursValidationResultList = data;

            this.hoursValidationResultList.forEach((num, i) => {
              if (
                this.hoursValidationResultList[i] !== undefined &&
                !this.hoursValidationResultList[i]
              ) {
                if (this.confirmHours != true) {
                  this.hoursValid = false;
                  this.dirtyFlag = false;

                  this.myFormGroup
                    .get('Hours_' + i)
                    .setErrors({ incorrect: true });
                  this.overallocationerror = false;
                }
              }
            });

            if ((!this.hoursValid && this.confirmHours) || this.hoursValid) {
              //alert("API Call successfully Done");
              this.hoursValid = true;
              //this.confirmHours = false;
              this.save();
            }
          });
      } else {
        //alert("Please select a different resource name");
        this.spinner.hide();
        this.buttonText = 'Please select a different resource name';
        setTimeout(() => {
          this.buttonText = 'Submit';
        }, 3000);
      }
    } else {
      //alert("validation error");
      this.buttonText = 'Validation error';
      setTimeout(() => {
        this.buttonText = 'Submit';
      }, 3000);
    }
  }

  @Output() isFormDirtyFlag: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public dirtyFlag = false;

  public makeDirty(controlName: string) {
    // if (!this.dirtyFlag) {
    //   this.formGroup.controls['editSave'].enable();
    //   this.dirtyFlag = true;
    //   this.isFormDirtyFlag.emit(this.dirtyFlag);

    // }
    if (!this.dirtyFlag) {
      this.dirtyFlag = true;
      this.isFormDirtyFlag.emit(this.dirtyFlag);
    }
    if (
      controlName == 'Period' ||
      controlName == 'Hours' ||
      controlName == 'Unconfirmed'
    ) {
      this.isValidationRequired = true;
    }

    this.overallocationerror = true;
  }

  public checkDirty() {
    if (!this.dirtyFlag) {
      if (this.formGroup.get('editPeriod').dirty) {
        this.makeDirty('Period');
      }
    }
  }

  save() {
    this.buttonText = 'Submitting...';

    let bookingDtos: any[] = [];
    this.bookingList.forEach((num, i) => {
      if (this.myFormGroup.get('chk_' + i).value == true) {
        bookingDtos.push({
          BookingId: num.BookingId,
          ResourceId: this.resourceId,
          JobId: num.JobId,
          BookingType: num.BookingType,
          Description: this.formGroup.get('Notes').value, //this.description,
          StartDate: this.myFormGroup.get('Periods_' + i).get('dtStart').value,
          EndDate: this.myFormGroup.get('Periods_' + i).get('dtEnd').value,
          Hours: !this.isPercentageSelected
            ? this.myFormGroup.get('Hours_' + i).value
            : this.hours, //num.Hours,
          Loading: this.isPercentageSelected
            ? this.myFormGroup.get('Hours_' + i).value
            : num.Loading,
          Unconfirmed: this.myFormGroup.get('Unconfirmed_' + i).value,
          Ghost: this.myFormGroup.get('Ghost_' + i).value,
          IsOverallocation: this.confirmHours,
          CurrentUserId: this.currentUserId,
          CurrentUserName: this.currentUserName,
          CurrentUserEmail: this.currentUserEmail,
          ComponentDescr: this.myFormGroup.get('EngagementComponent_' + i)
            .value,
          JobAssignmentDescr:
            this.jobAssignmentList?.find(
              (item) =>
                item.EngagementActivityID === this.selectedJobAssignment[i]
            )?.EngagementActivityDescr || null,
          ActionDescriptionId: 2,
          MeraBookingStatusId: 5,
          InstanceId: this.bookingList[0].InstanceId,
          ActualBookingId: num.BookingId,
          ParentBookingId: null,
        });
      }
    });

    let bookingActionDto = {
      IsPercentSelected: this.isPercentageSelected,
      RequestMode: JSON.parse(sessionStorage.getItem('requestMode')),
      Bookings: bookingDtos,
      UiViewSource: UiViewSourceEnum.EngamentView,
      Filter_EndDate: null,
      Filter_StartDate: null,
      Filter_InstanceId: null,
      Filter_JobId: null,
      Filter_ResourceId: null,
      BeyondDateFilterBookingActions: [],
    };

    //  v1
    // set filter data in bookingActionDto
    if (!!this.objFilteredData) {
      bookingActionDto.Filter_EndDate = this.objFilteredData.Filter_EndDate;
      bookingActionDto.Filter_StartDate = this.objFilteredData.Filter_StartDate;
      bookingActionDto.Filter_InstanceId =
        this.objFilteredData.Filter_InstanceId;
      bookingActionDto.Filter_JobId = this.objFilteredData.Filter_JobId;
      bookingActionDto.Filter_ResourceId =
        this.objFilteredData.Filter_ResourceId;
    }

    // this.getBeyondDateFilterBookingActionsDto;
    if (this.IsReplaceBeyondDatefilter) {
      this.getBeyondDateFilterBookingActionsDto(bookingActionDto);
    } else {
      bookingActionDto.BeyondDateFilterBookingActions = [];
    }

    this.editBookingSubscription = this.engagementServices
      .ReplaceBooking(bookingActionDto)
      .subscribe(
        (data: any) => {
          if ((data.status = '200')) {
            this.response = data.body;
            if (this.response.customResultId > 0) {
              this.engagementServices.setRquestNumber(
                this.response.customResultId
              );
              // alert("Responce Id = "+this.response.customResultId)
            }

            if (this.calledFromChild) {
              this.engagementServices.closeChildModal(true);
            } else {
              this.engagementServices.closeModal(true);
            }
          }
          this.buttonText = 'Submit';
        },
        (err) => {
          this.buttonText = 'Error';
        },
        () => {
          this.buttonText = 'Submit';
        }
      );
    this.dirtyFlag = false;
  }

  private getBeyondDateFilterBookingActionsDto(bookingActionDto) {
    let arrBeyondDateFilter: Array<BeyondDateFilterBookingActionsDto>;
    //let obj = new BeyondDateFilterBookingActionsDto() ;
    arrBeyondDateFilter = [];

    let DateFilterbooking: BeyondDateFilterBookingActionsDto = {
      MeraActionDescriptionId: MeraActionDescription.Replace,
      FromResourceId: this.OldresourceId,
      ToResourceId: this.resourceId,
      FromInstanceId: bookingActionDto.Bookings[0].InstanceId,
      ToInstanceId: bookingActionDto.Bookings[0].InstanceId,
      FromJobId: bookingActionDto.Bookings[0].JobId,
      ToJobId: bookingActionDto.Bookings[0].JobId,
    };
    arrBeyondDateFilter.push(DateFilterbooking);
    bookingActionDto.BeyondDateFilterBookingActions = arrBeyondDateFilter;
    return bookingActionDto;
  }

  dateRangeValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    if (
      control.value !== undefined &&
      control.value !== null &&
      (control.value[0] < today || control.value[1] < today)
    ) {
      return { ageRange: true };
    }
    return null;
  }

  setEngagementListData() {
    this.resourceListoptions = [];
    if (
      this.autocompleteResetvalue == null ||
      this.autocompleteResetvalue == ''
    ) {
      this.results = [];
    } else {
      this.results = this.sortedEngagementList;
    }
  }

  OnResourceItemSelect(event) {
    if (this.OldresourceId === event.ResourceId) {
      alert(
        `You can't select the current Resource. Please select another Resource`
      );
      return;
    }
    this.showSearchList = false;
    this.checkBoxDisbFlg = false;
    this.selectedResourceItem = event;
    this.formGroup.get('EngagementResourceName').setValue(event.ResourceName);
    //this.resourceRank = this.selectedResourceItem.RankDescription;
    this.resourceLocation = this.selectedResourceItem.LocationDescription;
    this.SLDescription = this.selectedResourceItem.SLDescription;
    this.departmentDescription =
      this.selectedResourceItem.DepartmentDescription;
    this.competencyDescription =
      this.selectedResourceItem.CompetencyDescription;
    //this.RankDescription = this.resourceRank;
    this.ActivityTypeDescription = this.selectedResourceItem.ActivityTypeDescription;
    this.LocationDescription = this.resourceLocation;
    this.resourceId = this.selectedResourceItem.ResourceId;
    this.ResourceName = this.selectedResourceItem.ResourceName;
    this.ChildRowDiv = false;
    this.checkAllSelected();
    this.formGroup.get('selectAll_chk').enable();
    this.formGroup.get('selectAll_chk').setValue(true);

    this.formGroup.get('Notes').enable();
    // this.hoursValid = true;
  }

  public key: string;
  checkAllSelected() {
    this.bookingList.forEach((num, i) => {
      if (
        num.IsCurrentEditWeek.valueOf() != true &&
        num.IsDisabledReplaceBooking.valueOf() != true
      ) {
        this.myFormGroup.get('chk_' + i).setValue(true);
        this.myFormGroup.get('Unconfirmed_' + i).enable();
        this.myFormGroup.get('Ghost_' + i).enable();
        this.myFormGroup.get('chk_' + i).enable();

        this.myFormGroup.get('Periods_' + i).enable();
        this.myFormGroup.get('Periods_' + i).markAsDirty();
        this.myFormGroup.get('Periods_' + i).markAsTouched();
        this.myFormGroup
          .get('Periods_' + i)
          .setValidators([Validators.required]);
        this.myFormGroup.get('Periods_' + i).updateValueAndValidity();

        this.myFormGroup.get('Hours_' + i).enable();
        this.myFormGroup.get('Hours_' + i).markAsDirty();
        this.myFormGroup.get('Hours_' + i).markAsTouched();
        this.myFormGroup
          .get('Hours_' + i)
          .setValidators([
            Validators.required,
            Validators.pattern(/^(?!0*\.?0+$)\d*\.?\d{1,2}$/),
            Validators.max(2147483647),
          ]);
        this.myFormGroup.get('Hours_' + i).updateValueAndValidity();
        this.dirtyFlag = true;
      }
    });

    this.ChildRecordsDisable = false;
  }

  searchValue = '';
  searchResource() {
    this.autocompleteResetvalue = this.formGroup.get(
      'EngagementResourceName'
    ).value;
    if (this.autocompleteResetvalue != null) {
      if (this.autocompleteResetvalue.length >= 2) {
        this.showSearchList = true;
        this.showSearchLoader = true;
        this.noresourcFoundFlg = false;
        this.searchValue = this.autocompleteResetvalue;
        this.resource.ResourceName = this.autocompleteResetvalue;
        this.resource.JobId = this.jobId;
        this.resource.ResourceId = +sessionStorage.getItem('resourceId');
        this.resource.LoggedInResourceID = +sessionStorage.getItem(
          'loggedin_resourceid'
        );
        this.resource.InstanceId = this.childRows.InstanceId;
        this.searchBookingSubscription = this.engagementServices
          .getResourceList(this.resource)
          .subscribe((data) => {
            this.sortedResourceList = this.orderPipe.transform(
              data,
              'ResourceName'
            );
            if (this.searchValue.length > 0) {
              this.results = this.sortedResourceList;
              this.showSearchLoader = false;
              this.noresourcFoundFlg = true;
              this.spinner.hide();
            } else {
              this.results = [];
              this.showSearchList = false;
            }
          });
      } else {
        this.results = [];
        this.showSearchList = false;
      }
    } else {
      this.results = [];
      this.showSearchList = false;
    }
  }

  onResourceClear() {
    this.checkBoxDisbFlg = true;
    this.noresourcFoundFlg = false;
    this.formGroup.get('EngagementResourceName').setValue('');
    this.searchValue = '';
    this.results = [];
    this.bookingList.forEach((num, i) => {
      if (
        num.IsCurrentEditWeek.valueOf() != true &&
        num.IsDisabledReplaceBooking.valueOf() != true
      ) {
        this.myFormGroup.get('chk_' + i).setValue(false);
        this.setControlsStatus(i, false);
      }
    });
    this.dirtyFlag = false;
    if (this.dirtyFlag) {
      this.isFormDirtyFlag.emit(this.dirtyFlag);
    }
    this.ChildRecordsDisable = true;
  }

  txtValue: string = null;
  ChildRecordsDisable: boolean = true;
  onResourceChange(value) {
    this.txtValue = value;
    if (this.txtValue == '') {
      this.bookingList.forEach((num, i) => {
        this.myFormGroup.get('chk_' + i).setValue(false);
        this.myFormGroup.get('Unconfirmed_' + i).disable();
        this.myFormGroup.get('Ghost_' + i).disable();
        this.myFormGroup.get('chk_' + i).disable();

        this.myFormGroup.get('Periods_' + i).disable();
        this.myFormGroup.get('Periods_' + i).markAsUntouched();
        this.myFormGroup.get('Periods_' + i).markAsPristine();
        this.myFormGroup.get('Periods_' + i).clearValidators();
        this.myFormGroup.get('Periods_' + i).updateValueAndValidity();
        this.myFormGroup.get('Periods_' + i).setErrors(null);

        this.myFormGroup.get('Hours_' + i).disable();
        this.myFormGroup.get('Hours_' + i).markAsUntouched();
        this.myFormGroup.get('Hours_' + i).markAsPristine();
        this.myFormGroup.get('Hours_' + i).clearValidators();
        this.myFormGroup.get('Hours_' + i).updateValueAndValidity();
        this.myFormGroup.get('Hours_' + i).setErrors(null);

        this.formGroup.get('selectAll_chk').disable();
        this.formGroup.get('selectAll_chk').setValue(false);

        this.formGroup.get('Notes').disable();
        this.formGroup.get('Notes').clearValidators();
        this.formGroup.get('Notes').updateValueAndValidity();
        this.formGroup.get('Notes').reset();

        this.dirtyFlag = false;
        this.hoursValid = true;
        this.setOldervalue(i);
      });
    }

    this.ChildRecordsDisable = true;
  }

  ngOnDestroy() {
    if (this.editBookingSubscription !== undefined) {
      this.editBookingSubscription.unsubscribe();
    }
  }

  setStartDateTime(inputDate) {
    let newDate = inputDate;
    if (newDate.getHours() === 0) {
      newDate.setHours(newDate.getHours() + 9);
      newDate.setMinutes(newDate.getMinutes() + 30);
    }
    return newDate;
  }

  setEndDateTime(inputDate) {
    let newDate = inputDate;
    if (newDate.getHours() === 0) {
      newDate.setHours(newDate.getHours() + 17);
      newDate.setMinutes(newDate.getMinutes() + 30);
    }
    return newDate;
  }

  public rowsToHighlight: any[] = [];
  // public isRowSelected = (e: RowArgs) => this.rowsToHighlight.indexOf(e.dataItem.HighlightStatus) >= 0;

  getBookingList() {
    let splitReqDto: EngagementBookingVM = JSON.parse(
      JSON.stringify(this.childRows)
    );
    splitReqDto.BookingId =
      this.childRows.ChildRowsExist === true ? 0 : splitReqDto.BookingId;
    splitReqDto.UiViewSource = UiViewSourceEnum.EngamentView;
    splitReqDto.MeraActionDescriptionId = ActionDescription.Replace;
    splitReqDto.IsPercentSelected = this.isPercentageSelected;

    this.spinner.show();
    this.bookingListSubscription = this.individualServices
      .getBookingSplittedInPastFuture(splitReqDto)
      .subscribe(
        (data) => {
          this.bookingList = data;

          this.bookingList1 = JSON.parse(JSON.stringify(this.bookingList));

          if (this.bookingList.length == 1) {
            this.onlyParent = true;
            this.onlyParentDirtyFlag = true;
          } else {
            this.onlyParent = false;
          }

          this.bookingList.forEach((element, index) => {
            // this.myFormGroup.addControl("Periods_" + index.toString(), fc);
            this.myFormGroup.addControl(
              'Periods_' + index.toString(),
              this.fb.group({
                // dtStart: [new Date(element.StartDate), Validators.required],
                // dtEnd: [new Date(element.EndDate), Validators.required],

                dtStart: [element.StartDate, Validators.required],
                dtEnd: [element.EndDate, Validators.required],
              })
            );

            this.selectedJobAssignment[index] = element?.JobAssignmentDescr;

            if (this.isPercentageSelected == true) {
              this.myFormGroup.addControl(
                'Hours_' + index.toString(),
                new FormControl(element.Loading, [
                  Validators.required,
                  Validators.pattern(/^(?!0*\.?0+$)\d*\.?\d{1,2}$/),
                ])
              );
            } else {
              this.myFormGroup.addControl(
                'Hours_' + index.toString(),
                new FormControl(element.Hours, [
                  Validators.required,
                  Validators.pattern(/^(?!0*\.?0+$)\d*\.?\d{1,2}$/),
                ])
              );
            }

            this.myFormGroup.addControl(
              'Unconfirmed_' + index.toString(),
              new FormControl(element.Unconfirmed)
            );

            this.myFormGroup.addControl(
              'EngagementComponent_' + index.toString(),
              new FormControl(element.ComponentDescr)
            );
            this.myFormGroup.addControl(
              'Ghost_' + index.toString(),
              new FormControl(element.Ghost)
            );
            this.myFormGroup.addControl(
              'chk_' + index.toString(),
              new FormControl('')
            );
            this.myFormGroup.addControl(
              'Notes_' + index.toString(),
              new FormControl(element.Description)
            );
            //Added Missing code to resolve current week issue
            this.myFormGroup.get('Periods_' + index).disable();
            this.myFormGroup.get('Hours_' + index).disable();
            this.myFormGroup.get('Unconfirmed_' + index).disable();
            this.myFormGroup.get('chk_' + index).disable();
            this.myFormGroup.get('Ghost_' + index).disable();
          });

          this.formGroup.get('selectAll_chk').disable();
          this.formGroup.get('Notes').disable();
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  changeCheck(index, args) {
    if (args.checked) {
      this.isAllChecked = true;
      this.dirtyFlag = true;
      this.bookingList.forEach((num, i) => {
        if (
          i != index &&
          this.myFormGroup.get('chk_' + i).value == false &&
          num.IsCurrentEditWeek.valueOf() != true &&
          num.IsDisabledReplaceBooking.valueOf() != true
        ) {
          this.isAllChecked = false;
          return;
        }
      });
      this.formGroup.get('selectAll_chk').setValue(this.isAllChecked);
    } else {
      this.formGroup.get('selectAll_chk').setValue(false);
      this.dirtyFlag = false;
      this.bookingList.forEach((num, i) => {
        if (
          i != index &&
          this.myFormGroup.get('chk_' + i).value == true &&
          num.IsCurrentEditWeek.valueOf() != true &&
          num.IsDisabledReplaceBooking.valueOf() != true
        ) {
          this.dirtyFlag = true;
          return;
        }
      });
      this.setOldervalue(index);
    }
    this.setControlsStatus(index, args.checked);
    this.myFormGroup.get('chk_' + index).enable();
    // this.dirtyFlag =
    // !(!this.myFormGroup.get((this.isPercentageSelected ? 'editLoading_' : 'editHours_')+ index).value
    // || this.myFormGroup.get((this.isPercentageSelected ? 'editLoading_' : 'editHours_') + index).value.trim() == ''
    // || isNaN(+this.myFormGroup.get((this.isPercentageSelected ? 'editLoading_' : 'editHours_') + index).value));
  }

  public confirmHoursChange() {
    if (this.confirmHours == true) {
      this.bookingList.forEach((num, i) => {
        if (this.myFormGroup.get('Hours_' + i).value != '') {
          this.myFormGroup.get('Hours_' + i).setErrors(null);

          this.dirtyFlag = true;
        }
      });
    } else {
      this.dirtyFlag = false;
    }
  }

  public changeSelectAll(event) {
    this.bookingList.forEach((num, i) => {
      if (
        num.IsCurrentEditWeek.valueOf() != true &&
        num.IsDisabledReplaceBooking.valueOf() != true
      ) {
        this.myFormGroup.get('chk_' + i).setValue(event.checked);
        this.setControlsStatus(i, event.checked);
      }
    });
    this.dirtyFlag = event.checked;
    if (this.dirtyFlag) {
      this.isFormDirtyFlag.emit(this.dirtyFlag);
    }
  }

  setControlsStatus(index, isEnabled) {
    if (!isEnabled) {
      this.myFormGroup.get('Unconfirmed_' + index).disable();
      this.myFormGroup.get('EngagementComponent_' + index).disable();
      this.myFormGroup.get('Ghost_' + index).disable();
      this.myFormGroup.get('Periods_' + index).disable();
      this.myFormGroup.get('Periods_' + index).markAsUntouched();
      this.myFormGroup.get('Periods_' + index).markAsPristine();
      this.myFormGroup.get('Periods_' + index).clearValidators();
      this.myFormGroup.get('Periods_' + index).updateValueAndValidity();
      this.myFormGroup.get('Periods_' + index).setErrors(null);
      //this.myFormGroup.get("Periods_"+index).setValue(args.BsRangeDate);

      this.myFormGroup.get('Hours_' + index).disable();
      this.myFormGroup.get('Hours_' + index).markAsUntouched();
      this.myFormGroup.get('Hours_' + index).markAsPristine();
      this.myFormGroup.get('Hours_' + index).clearValidators();
      this.myFormGroup.get('Hours_' + index).updateValueAndValidity();
      this.myFormGroup.get('Hours_' + index).setErrors(null);
      //  this.myFormGroup.get('Hours_'+index).setValue(args.Hours);
    } else {
      this.myFormGroup.get('Unconfirmed_' + index).enable();
      this.myFormGroup.get('EngagementComponent_' + index).enable();
      this.myFormGroup.get('Ghost_' + index).enable();
      this.myFormGroup.get('Periods_' + index).enable();
      this.myFormGroup.get('Periods_' + index).markAsDirty();
      this.myFormGroup.get('Periods_' + index).markAsTouched();
      this.myFormGroup
        .get('Periods_' + index)
        .setValidators([Validators.required]);
      this.myFormGroup.get('Periods_' + index).updateValueAndValidity();

      this.myFormGroup.get('Hours_' + index).enable();
      this.myFormGroup.get('Hours_' + index).markAsDirty();
      this.myFormGroup.get('Hours_' + index).markAsTouched();
      this.myFormGroup
        .get('Hours_' + index)
        .setValidators([
          Validators.required,
          Validators.pattern(/^(?!0*\.?0+$)\d*\.?\d{1,2}$/),
        ]);
      this.myFormGroup.get('Hours_' + index).updateValueAndValidity();
    }
  }

  public setOldervalue(index) {
    this.bookingList1.forEach((num, i) => {
      if (index == i) {
        // this.myFormGroup.get("Periods_" + index).get("dtStart").setValue(new Date(num.StartDate));
        // this.myFormGroup.get("Periods_" + index).get("dtEnd").setValue(new Date(num.EndDate));
        this.myFormGroup
          .get('Periods_' + index)
          .get('dtStart')
          .setValue(num.StartDate);
        this.myFormGroup
          .get('Periods_' + index)
          .get('dtEnd')
          .setValue(num.EndDate);
        this.myFormGroup.get('Hours_' + index).setValue(num.Hours);
        if (num.BookingType.includes('Unconfirmed')) {
          this.myFormGroup.get('Unconfirmed_' + index).setValue(true);
        } else {
          this.myFormGroup.get('Unconfirmed_' + index).setValue(false);
        }
        this.myFormGroup.get('Ghost_' + index).setValue(num.Ghost);
      }
    });
  }

  public child_chk_enabled = 0;
  public child_chk_disabled = 0;
  checkChildSelect(args) {
    this.bookingList1.forEach((num, i) => {
      if (this.myFormGroup.get('chk_' + i).value == true) {
        this.child_chk_enabled = this.child_chk_enabled + 1;
      }
      if (this.myFormGroup.get('chk_' + i).value == false) {
        this.child_chk_disabled = this.child_chk_disabled + 1;
      }
    });

    if (this.child_chk_enabled == 1 && !args.checked) {
      this.formGroup.get('selectAll_chk').setValue(false);

      this.formGroup.get('Notes').disable();
      this.formGroup.get('Notes').markAsUntouched();
      this.formGroup.get('Notes').markAsPristine();
      this.formGroup.get('Notes').clearValidators();
      this.formGroup.get('Notes').updateValueAndValidity();
      this.formGroup.get('Notes').reset();

      this.dirtyFlag = false;
    } else {
      this.formGroup.get('Notes').enable();
      this.formGroup.get('Notes').markAsDirty();
      this.formGroup.get('Notes').markAsTouched();
      this.dirtyFlag = true;
    }

    this.child_chk_disabled = 0;
    this.child_chk_enabled = 0;
  }

  // EditReplace: number = 0;
  // getCurrentWeek() {
  //   this.editBookingSubscription = this.engagementServices.getCurrentWeek().subscribe(
  //     (data: any) => {
  //       this.EditReplace = data.Replace;

  //       const currentDate = new Date();

  //       if (this.EditReplace == 1) {

  //         this.enabledWeek(false);

  //       }
  //       if (this.EditReplace == 0 || this.EditReplace == null) {
  //         this.enabledWeek(true);
  //       }
  //     });
  // }

  enabledWeek(isCurrentWeekEditable) {
    if (this.currentWeekActionDTO.IsDisabledReplaceBookingCurrWeek === true) {
      isCurrentWeekEditable = false;
    }

    if (isCurrentWeekEditable) {
      //this.startOfWeek.setMinutes(this.startOfWeek.getMinutes() - this.startOfWeek.getTimezoneOffset());
    } else {
      //this.startOfWeek.setDate(this.startOfWeek.getDate() + 7);
      let dt = new Date(this.startOfWeek);
      this.startOfWeek = new Date(dt.setDate(dt.getDate() + 7)).toISOString();
      //this.startOfWeek.setMinutes(this.startOfWeek.getMinutes() - this.startOfWeek.getTimezoneOffset());
    }

    return this.startOfWeek;

    // const dayNeeded = 7 //For Saturday
    // const currentDay = moment().isoWeekday();
    // if (this.EditReplace === 1) {
    //   isCurrentWeekEditable = false;
    // }
    // if(isCurrentWeekEditable){
    //   if (currentDay === dayNeeded) {
    //     let day = moment().day(dayNeeded);
    //     this.startOfWeek = new Date(day.year(),day.month(),day.date())
    //   }else{
    //     let day = moment().subtract(1, 'weeks').isoWeekday(dayNeeded);
    //     this.startOfWeek = new Date(day.year(),day.month(),day.date());
    //   }
    // }else{
    //   if (currentDay === dayNeeded) {
    //     let day = moment().add(1, 'weeks').isoWeekday(dayNeeded);
    //     this.startOfWeek = new Date(day.year(),day.month(),day.date());
    //   }else{
    //     let day = moment().day(dayNeeded);
    //     this.startOfWeek = new Date(day.year(),day.month(),day.date());

    //   }
    // }
    //this.startOfWeek = this.getFirstDateOfWeek(this.todaysDate);
  }

  getFirstDateOfWeek(anyDateOfWeek) {
    // date.getDay() RETURNS Week Day Index: SUN 0, MON 1, TUE 2, WED 3, THU 4, FRI 5, SAT 6.
    let date = new Date(anyDateOfWeek);
    let firstDayOfWeekIndex: number = 6; //Week Day Index: SUN 0, MON 1, TUE 2, WED 3, THU 4, FRI 5, SAT 6.
    let daysToShiftBack = (7 + (date.getDay() - firstDayOfWeekIndex)) % 7;
    let firstDateOfWeek = new Date(
      date.setDate(date.getDate() - daysToShiftBack)
    );
    return firstDateOfWeek.toISOString();
  }

  isValidInput_my(fieldName, index): boolean {
    return (
      this.myFormGroup.controls[fieldName + index].invalid &&
      (this.myFormGroup.controls[fieldName + index].dirty ||
        this.myFormGroup.controls[fieldName + index].touched)
    );
  }
  searchBookingComponentData(index) {
    this.engagementComponentList = [];
    this.showSearchListBookingComponent = false;
    const bkVAlue =
      this.myFormGroup.controls['EngagementComponent_' + index].value;
    if (bkVAlue != null && bkVAlue.trim().length >= 2) {
      this.showSearchBCLoader[index] = true;
      const param = new BookingComponentVm();
      param.SearchKey = bkVAlue;
      param.InstanceId = this.selectedInstanceId;
      this.showSearchBCList[index] = true;
      this.restService.getBookingComponent(param).subscribe(
        (data) => {
          this.engagementComponentList = data;
        },
        (error) => {
          console.log(error);
        },
        () => {
          this.showSearchBCLoader[index] = false;
        }
      );
    }
  }
  OnEngagementBookingSelect(event, item, index) {
    event.stopPropagation();
    this.selectedEngagementBooking[index] = item;
    this.myFormGroup.controls['EngagementComponent_' + index].patchValue(
      item?.ComponentDescr
    );
    this.showSearchBCList[index] = false;
  }

  resetBookingComponent(index) {
    this.showSearchBCList[index] = false;
    this.showSearchBCLoader[index] = false;
    this.myFormGroup.controls['EngagementComponent_' + index].patchValue('');
  }
}
